import usePWAInstall from '@/hooks/usePWAInstall';
import { motion } from 'framer-motion';
import Images from '../common/Images';

const APK_DOWNLOAD_URL = '/downloads/app.apk';
const APP_ICON = '/logo.svg';

const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/share/1D4pgNs7NG/',
    icon: '/footer/fb.svg',
  },
  //   {
  //     name: 'Instagram',
  //     href: 'https://www.instagram.com/aronno_tv/',
  //     icon: '/footer/fb.svg',
  //   },
  {
    name: 'Telegram',
    href: 'https://t.me/+RzU5AgjioIlhOGQ0',
    icon: '/footer/teli.svg',
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@AronnotvlivE',
    icon: '/footer/yt.svg',
  },
  //   {
  //     name: 'Email',
  //     href: 'mailto:aronnotvlive@gmail.com',
  //     icon: '/footer/fb.svg',
  //   },
];

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.07, duration: 0.5, ease: [0.22, 1, 0.36, 1] } as const,
  }),
};

export const Footer = () => {
  //   const { canInstall, isInstalled, isIOS, triggerInstall, setShowPopup } = usePWAInstall();

  //   const handleInstall = () => {
  //     if (isIOS) setShowPopup(true);
  //     else triggerInstall();
  //   };

  return (
    <footer className="relative w-full bg-[#0E0E0E] overflow-hidden">
      {/* Gradient top border */}
      <div className="h-[2px] w-full bg-btn-gradient2 opacity-60" />

      {/* Ambient glow */}
      <div
        className="pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2 w-[600px] h-[240px] opacity-10 blur-3xl rounded-full"
        style={{ background: 'radial-gradient(ellipse, #FA5629 0%, transparent 70%)' }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-5 py-10 md:py-14">
        {/* ── Brand + Download row ────────────────────────────────────── */}
        <motion.div
          className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 mb-4"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* Brand */}
          <motion.div className="flex items-center gap-4" custom={0} variants={fadeUp}>
            <div className="relative">
              <Images
                src={APP_ICON}
                alt="Aronno TV"
                className="rounded-2xl object-cover max-w-[140px]"
              />
              {/* Live pulse */}
              {/* <span className="absolute -top-1 -right-1 flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FA5629] opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#FA5629]" />
              </span> */}
            </div>
            {/* <div>
              <p className="text-primary-text font-bold text-lg leading-tight">Aronno TV</p>
              <p className="text-[#666] text-xs mt-0.5">Live. Anytime. Anywhere.</p>
            </div> */}
          </motion.div>

          {/* Download buttons */}
          <motion.div className="flex items-center gap-3 flex-wrap" custom={1} variants={fadeUp}>
            {/* {!isInstalled && (canInstall || isIOS) && (
              <motion.button
                onClick={handleInstall}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.97 }}
                className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-primary-text text-sm font-semibold bg-btn-gradient2 shadow-md"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2.2}
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 18l-5-5m5 5l5-5m-5 5V4"
                  />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18" />
                </svg>
                {isIOS ? 'Add to Home' : 'Install App'}
              </motion.button>
            )}

            {!isIOS && (
              <motion.a
                href={APK_DOWNLOAD_URL}
                download
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.97 }}
                className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-primary-text text-sm font-semibold border border-primary-boder2 bg-[#FA56291A] hover:bg-[#FA562930] transition-colors"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2.2}
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
                  />
                </svg>
                Download APK
              </motion.a>
            )} */}
          </motion.div>
        </motion.div>

        {/* Social */}
        <motion.div
          className="flex flex-col items-start sm:items-end gap-4"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <motion.p
            custom={0}
            variants={fadeUp}
            className="text-sm font-semibold uppercase tracking-[1.5px] text-[#FA5629]"
          >
            Follow Us
          </motion.p>
          <div className="flex items-center gap-2.5 flex-wrap">
            {SOCIAL_LINKS.map((social, i) => (
              <motion.a
                key={social.name}
                href={social.href}
                target={social.href.startsWith('mailto:') ? undefined : '_blank'}
                rel="noopener noreferrer"
                aria-label={social.name}
                custom={i}
                variants={fadeUp}
                whileHover={{ scale: 1.14 }}
                whileTap={{ scale: 0.95 }}
                title={social.name}
                className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 transition-all duration-150 hover:border-[#FA562966] hover:bg-[#FA56291A]"
              >
                <Images src={social.icon} alt={social.name} className="object-contain" />
              </motion.a>
            ))}
          </div>
          <motion.a
            custom={5}
            variants={fadeUp}
            href="mailto:aronnotvlive@gmail.com"
            className="text-[11px]  hover:text-[#FA5629] transition-colors tracking-wide"
          >
            aronnotvlive@gmail.com
          </motion.a>
        </motion.div>
        {/* ── Divider ─────────────────────────────────────────────────── */}
        <div className="h-px w-full bg-primary-border/20 mt-2 mb-4" />
        {/* ── About + Social row ──────────────────────────────────────── */}
        <div className="flex flex-col sm:flex-row justify-between gap-10">
          {/* About links */}

          {/* About links */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            className="max-w-xs"
          >
            <motion.p
              custom={0}
              variants={fadeUp}
              className="text-sm font-semibold uppercase tracking-[1.5px] text-[#FA5629] mb-3"
            >
              About
            </motion.p>
            <motion.p custom={1} variants={fadeUp} className="text-[13px]  leading-relaxed">
              Aronno TV is your go-to destination for live streaming and Quizzes — available
              anytime, anywhere.
            </motion.p>
          </motion.div>
        </div>

        {/* ── Bottom bar ──────────────────────────────────────────────── */}
        <motion.div
          className="mt-10 pt-5 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-2"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <p className="text-[11px] ">
            © {new Date().getFullYear()} Aronno TV. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#FA5629] animate-pulse" />
            <span className="text-[11px] ">Streaming live</span>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
